// components/InputField.js
import React from 'react';

const InputField = ({ label, type, required, value, onChange, error  }) => {
  return (
    <div className="input-field">
      <label>
        {label} {required && <span className="required">*</span>}
      </label>
      <input 
        type={type} 
        required={required} 
        value={value} // Controlled input
        onChange={onChange} // Handle change via props 
      />
      {error && <p className="error-text">{error}</p>} {/* Display error message */}
    </div>
  );
};

export default InputField;
